import { StorageAccessor } from "../StorageAccesor/StorageAccesor";
import { FormFields, FormReducer, FormStateType } from "../Helpers/formTypes";
import { isObjectEmpty } from "../Helpers";
import React, { useEffect } from "react";
import { WaitlistViewModel } from "../../../Blocks/Waitlist/WaitlistViewModel.csharp";

export const usePersistedSelection = (
  dispatch: React.Dispatch<any>,
  setStep: (step: number) => void,
  waitlist?: WaitlistViewModel
) => {
  useEffect(() => {
    const persistedSelection = new StorageAccessor().getItem() as FormStateType;
    const isNotEmpty = isObjectEmpty(persistedSelection) == false;
    if (isNotEmpty && !waitlist?.contentId) {
      if (persistedSelection.specialization?.id) {
        dispatch({
          type: FormReducer.update,
          field: FormFields.specialization,
          payload: persistedSelection.specialization,
        });
      }

      if (persistedSelection.service?.id) {
        dispatch({
          type: FormReducer.update,
          field: FormFields.service,
          payload: persistedSelection.service,
        });
      }

      if (persistedSelection.location?.id) {
        dispatch({
          type: FormReducer.update,
          field: FormFields.location,
          payload: persistedSelection.location,
        });
      }

      if (persistedSelection.doctor?.id) {
        dispatch({
          type: FormReducer.update,
          field: FormFields.doctor,
          payload: persistedSelection.doctor,
        });
      }

      if (persistedSelection.appointment.serviceId) {
        dispatch({
          type: FormReducer.update,
          field: FormFields.appointment,
          payload: {
            ...persistedSelection.appointment,
            startTime: new Date(persistedSelection.appointment.startTime),
            endTime: new Date(persistedSelection.appointment.endTime),
          },
        });
      }

      if (persistedSelection.selectedMonth) {
        dispatch({
          type: FormReducer.update,
          field: FormFields.selectedMonth,
          payload: persistedSelection.selectedMonth,
        });
      }

      if (persistedSelection.selectedDay) {
        dispatch({
          type: FormReducer.update,
          field: FormFields.selectedDay,
          payload: persistedSelection.selectedDay,
        });
      }

      if (persistedSelection.currentStep) {
        setStep(persistedSelection.currentStep);
        dispatch({
          type: FormReducer.update,
          field: FormFields.currentStep,
          payload: persistedSelection.currentStep,
        });
      }

      if (persistedSelection.remoteContact) {
        dispatch({
          type: FormReducer.update,
          field: FormFields.remoteContact,
          payload: persistedSelection.remoteContact,
        });
      }

      if (persistedSelection.bookingSessionId) {
        dispatch({
          type: FormReducer.update,
          field: FormFields.bookingSessionId,
          payload: persistedSelection.bookingSessionId,
        });
      }

      if (persistedSelection.wasDifferentTimeZoneModalShown) {
        dispatch({
          type: FormReducer.update,
          field: FormFields.wasDifferentTimeZoneModalShown,
          payload: persistedSelection.wasDifferentTimeZoneModalShown,
        });
      }
    }
  }, []);
};
